import { useEffect, useState } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import './SmartAttachmentEditor.css';

interface Props {
  data: string;
  onEditorStateChange: (e: any, index?: number) => void;
  isFocused?: boolean;
  index?: number;
}

/**
 * Editor component for smart attachments
 */
export const SmartAttachmentEditor = ({ data, onEditorStateChange, isFocused, index }: Props) => {
  const [value, setValue] = useState(data);

  useEffect(() => {
    onEditorStateChange(value, index);
  }, [value]);

  // toolbar options
  const toolbarOptions = [
    ['bold', 'italic', 'underline', 'strike'], // toggled buttons
    [{ list: 'ordered' }, { list: 'bullet' }],
    [{ script: 'sub' }, { script: 'super' }],
    [{ indent: '-1' }, { indent: '+1' }], // outdent/indent
    [{ direction: 'rtl' }], // text direction
    [{ header: [1, 2, 3, 4, 5, 6, false] }],
    ['link', 'image'],
    [{ color: [] }, { background: [] }],
    [{ font: [] }],
    [{ align: [] }],
  ];

  return (
    <>
      <div className="text-editor">
        {/* editable -  toolbar */}
        <div className={`${isFocused ? 'block' : 'hidden'}`}>
          <ReactQuill
            onChange={setValue}
            modules={{
              toolbar: toolbarOptions,
            }}
            theme="snow"
            value={value}
          />
        </div>
        {/* readonly - no toolbar */}
        <div className={`${isFocused ? 'hidden' : 'block'}`}>
          <ReactQuill
            modules={{
              toolbar: false,
            }}
            theme="snow"
            value={value}
          />
        </div>
      </div>
    </>
  );
};
